const moment = require('moment');

class Note {
  constructor(data) {
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get content() {
    return this.data.content;
  }

  get preview() {
    return this.data.content;
  }

  get date() {
    return moment(this.data.createdAt).fromNow();
  }
}

module.exports = Note;


// WEBPACK FOOTER //
// ./src/models/note.js